import EditRegistration from "./EditRegistration";
export default EditRegistration;
